import React from 'react'
import { PingPrivilegeLogo } from './'

const ProcyonLogoIcon = ({ className = '' }) => {
  return <PingPrivilegeLogo className={className} />
}

export { ProcyonLogoIcon }
